export default {
  loading: false,
  warehouses: [],
  accessDrivers: [],
  accessDriver: {},
};



// WEBPACK FOOTER //
// ./src/features/private/settings/pages/access-driver/store/states.js